import { MESSAGE_KEY_DZ_FILE_UPLOAD, UPLOAD_FILE_ENDPOINT } from "../../core/const/Constant";
import { useDoPostWindowMessage, useSubcribeWindowMessage } from "../hook/useSubcribeWindowMessage";
// import { subscribeMessage } from "../services/WindowMessage";
import Utils from "../utils/Common.util";
import { needForwardToIFrame, POST, UPLOAD } from "./_base.api";


/**@type {Map<string, AbortController>} */
const _abortUploadSignal = new Map();

const { doPostMessage } = useDoPostWindowMessage();

useSubcribeWindowMessage(MESSAGE_KEY_DZ_FILE_UPLOAD, async args => {
    if (!Utils.IsIFrame()) {
        return;
    }
    const { uuid, file, fieldCode } = args;
    const json = await uploadFile(uuid, file, fieldCode);

    // Check same form
    if (json.uuid === uuid && fieldCode == json.fieldCode) {
        doPostMessage(MESSAGE_KEY_DZ_FILE_UPLOAD, json)
    }
})


const forwardToIFrame = {
    /**
      * 
      * @param {*} uuid 
      * @param {IFile} file 
      * @param {string} fieldCode 
      * 
      * @returns 
      */
    uploadFile: (uuid, file, fieldCode) => {
        return new Promise(next => {
            const unsub = useSubcribeWindowMessage(MESSAGE_KEY_DZ_FILE_UPLOAD, async data => {
                const { fileId } = data;
                if (fileId === file.fileId) {
                    next(data);
                    unsub();
                }
            })
            if (typeof uuid === 'string') {
                /**@type {ArrayBuffer} */
                const arr = file.fileData;
                doPostMessage(MESSAGE_KEY_DZ_FILE_UPLOAD, { uuid, file, fieldCode }, [arr]);
            }
        })
    }
}


/**
 * 
 * @param {string} uuid 
 * @param {IFile} file 
 * @param {string} fieldCode 
 * @returns {Promise<IResponse<any>  & {uuid:string, fieldCode:string, fileId:string}>}
 */
export const uploadFile = async (uuid, file, fieldCode) => {
    if (needForwardToIFrame()) {
        return forwardToIFrame.uploadFile(uuid, file, fieldCode);
    }

    const abortSignal = new AbortController();
    _abortUploadSignal.set(file.fileId, abortSignal);
    const API_URL = UPLOAD_FILE_ENDPOINT + `?uuid=${uuid}`
    const { fileData, size, name, type, fileId } = file;
    const blob = new Blob([fileData]);

    const fd = new FormData();
    fd.append('file', new File([blob], name));
    fd.append('code', fieldCode);
    const responseData = await POST(API_URL, fd, { includeJsonContentType: false });
    // const responseData = await resp.json();
    _abortUploadSignal.delete(file.fileId);
    return { ...responseData, uuid, fieldCode, fileId };
}